document.addEventListener('DOMContentLoaded', function() {

  // ─── Mobile Menu Toggle ───────────────────────────────────────────────────
  var mobileMenuBtn = document.getElementById('mobileMenuBtn');
  var mobileMenu = document.getElementById('mobileMenu');

  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = mobileMenu.style.display === 'block';
      mobileMenu.style.display = isOpen ? 'none' : 'block';
      mobileMenuBtn.innerHTML = isOpen
        ? '<i class="fas fa-bars"></i>'
        : '<i class="fas fa-times"></i>';
      mobileMenuBtn.setAttribute('aria-expanded', String(!isOpen));
    });

    document.addEventListener('click', function(e) {
      if (mobileMenu.style.display === 'block' && !mobileMenu.contains(e.target) && e.target !== mobileMenuBtn) {
        mobileMenu.style.display = 'none';
        mobileMenuBtn.innerHTML = '<i class="fas fa-bars"></i>';
        mobileMenuBtn.setAttribute('aria-expanded', 'false');
      }
    });

    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileMenu.style.display = 'none';
        mobileMenuBtn.innerHTML = '<i class="fas fa-bars"></i>';
        mobileMenuBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // ─── Cart Toast ───────────────────────────────────────────────────────────
  var toast = document.getElementById('cart-toast');
  var toastCount = document.getElementById('cart-toast-count');
  var toastText = document.getElementById('cart-toast-text');
  var toastSub = document.getElementById('cart-toast-sub');

  function showCartToast(itemCount, productTitle) {
    if (!toast) return;
    toastCount.textContent = itemCount;
    toastText.textContent = 'Added to Cart!';
    toastSub.textContent = productTitle
      ? productTitle.substring(0, 32) + (productTitle.length > 32 ? '\u2026' : '')
      : itemCount + ' item' + (itemCount !== 1 ? 's' : '') + ' in cart';
    toast.classList.add('show');
    // Toast stays visible until user clicks × close button
  }

  // Navigate to cart when the toast body is clicked (but not the close button)
  if (toast) {
    toast.addEventListener('click', function(e) {
      if (e.target.closest('#cart-toast-close')) return;
      window.location.href = '/cart';
    });
  }

  // Update header cart count badge
  function updateHeaderCartCount(count) {
    var badge = document.querySelector('.cart-count');
    if (count > 0) {
      if (!badge) {
        var cartIcon = document.querySelector('a[href="/cart"] .fa-shopping-bag');
        if (cartIcon) {
          badge = document.createElement('span');
          badge.className = 'cart-count';
          cartIcon.parentElement.appendChild(badge);
        }
      }
      if (badge) badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  // ─── AJAX Add to Cart ────────────────────────────────────────────────────
  // Intercept all add-to-cart forms (product cards + product page)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.matches('form[action="/cart/add"]')) return;

    // Check if this has a Buy Now intent flag (set by JS below)
    if (form.dataset.buyNow === 'true') return; // let it submit normally

    e.preventDefault();

    var formData = new FormData(form);
    var submitBtn = form.querySelector('button[type="submit"]');
    var originalHTML = submitBtn ? submitBtn.innerHTML : '';

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(function(res) { return res.json(); })
    .then(function(item) {
      // Get current cart count
      return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        updateHeaderCartCount(cart.item_count);
        showCartToast(cart.item_count, item.title);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = '<i class="fas fa-check"></i> Added!';
          setTimeout(function() { submitBtn.innerHTML = originalHTML; }, 2000);
        }
      });
    })
    .catch(function(err) {
      console.error('Cart error:', err);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalHTML;
      }
    });
  });

  // ─── Buy Now — add to cart then go to checkout ───────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.buy-now-btn');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.dataset.variantId;
    var qty = btn.dataset.qty || 1;
    if (!variantId) {
      // Fallback: navigate to product URL
      window.location.href = btn.href || '/collections/all';
      return;
    }

    btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
    btn.style.pointerEvents = 'none';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      window.location.href = '/checkout';
    })
    .catch(function() {
      window.location.href = '/checkout';
    });
  });

});
